import './login-buttons.component.scss';

import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';

import { useTranslation } from '../../../i18n';
import type { AccountSettings } from '../../../models/common.model';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { LegacyAuthModalState, LoginType } from '../../models/auth.model';
import { authenticationFlowService } from '../../services/authentication-flow.service';
import { selectIsAuthenticated } from '../../store/auth.selectors';
import { attachAuthElements } from '../../store/auth.thunk';

export interface LoginButtonProps {
  accountSettings?: AccountSettings;
  loginTypes: LoginType[];
  loginRedirectUrl: string;
  useDefault: boolean;
  defaultLoginButtonText: string;
  marginTop: number;
  membershipProduct: boolean;
  gatedProduct: boolean;
}

export const LoginButtons = ({
  accountSettings,
  loginTypes = [],
  loginRedirectUrl,
  useDefault,
  defaultLoginButtonText,
  marginTop = 20,
  membershipProduct,
  gatedProduct,
}: LoginButtonProps) => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const { t } = useTranslation();

  const [loginUrl, setLoginUrl] = useState('');
  const [loginButtonText, setLoginButtonText] = useState('');
  const [customerLogin, setCustomerLogin] = useState<boolean | undefined>(false);

  const exists = (value: any) => {
    return !!value && value.trim() !== '';
  };

  useEffect(() => {
    initializeComponent();

    if (!isAuthenticated) {
      dispatch(attachAuthElements());
    }
  }, [
    loginTypes,
    accountSettings,
    loginRedirectUrl,
    useDefault,
    defaultLoginButtonText,
    membershipProduct,
    gatedProduct,
  ]);

  const initializeComponent = () => {
    let url = '';
    if (exists(accountSettings?.productFormLoginUrl)) {
      url = accountSettings.productFormLoginUrl;
    }

    if (url) {
      if (exists(accountSettings?.productFormLoginRedirectParameter)) {
        url = url + '?' + accountSettings?.productFormLoginRedirectParameter + '=';
      }

      if (loginRedirectUrl) {
        url = url + encodeURIComponent(loginRedirectUrl);
      }
    }
    setLoginUrl(url);

    let buttonText = '';
    if (exists(accountSettings?.productFormLoginButtonText) && !useDefault) {
      buttonText = accountSettings.productFormLoginButtonText;
    } else if (defaultLoginButtonText) {
      buttonText = defaultLoginButtonText;
    } else {
      buttonText = membershipProduct || gatedProduct ? t('auth.logInToPurchase') : t('auth.signIn');
    }
    setLoginButtonText(buttonText);
    setCustomerLogin(loginTypes?.includes(LoginType.CUSTOMER));
  };

  const openAuthenticationModal = async () => {
    await authenticationFlowService.initiateAuthentication({
      state: LegacyAuthModalState.CREATE_ACCOUNT,
    });
  };

  const renderLoginButton = () => {
    if (loginUrl) {
      return (
        <a
          href={loginUrl}
          class="single-customer-login-button btn button button--primary"
          style={{ marginTop: marginTop ? `${marginTop}px` : undefined }}
        >
          {loginButtonText}
        </a>
      );
    }

    return (
      <button
        onClick={openAuthenticationModal}
        class="single-customer-login-button btn button button--primary"
        type="button"
        style={{ marginTop: marginTop ? `${marginTop}px` : undefined }}
      >
        {loginButtonText}
      </button>
    );
  };

  return (
    <div class={`single-login-container ${isAuthenticated ? 'single-hidden' : ''}`}>
      <div class={`single-login-option ${!customerLogin ? 'single-hidden' : ''}`}>
        <section class="single-gate-customer-login">{renderLoginButton()}</section>
      </div>
    </div>
  );
};
